<template>
  <div
    v-if="loadingDetail"
    class="eu-pa_6 eu-align_center"
  >
    <emd-loader type="_invert" />
  </div>
  <invite-detail-content
    v-else
    :invite="invite"
    @getInvite="getInvite"
  />
</template>
<script>
import InvitesManager from '@/views/Team/Invites/invites.manager.js'
import { EmdLoader } from 'emerald-vue/src/components'
import { mapGetters, mapActions } from 'vuex'
import InviteDetailContent from '@/views/Team/Invites/components/InviteDetailContent.vue'

export default {
  name: 'InvitesDetail',
  components: {
    InviteDetailContent,
    EmdLoader
  },
  data () {
    return {
      loadingDetail: true,
      invite: {}
    }
  },
  computed: {
    ...mapGetters(['permissionIsEnabled']),
    inviteId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions(['GET_INVITE']),
    getInvite () {
      this.loadingDetail = true
      this.GET_INVITE({
        inviteId: this.inviteId
      }).then(res => {
        this.invite = new InvitesManager([res]).getOne()
        this.loadingDetail = false
      })
    }
  },
  created () {
    this.getInvite()
  }
}
</script>
